import { NUMBER_OF_CHARACTERS_ALLOWED_IN_TITLE } from "@/forms/AddActivityForm/TitleInput";
import InputField from "@medoma/components/InputField/InputField";
import { useLingui } from "@lingui/react/macro";
import { useFormContext, type FieldValues } from "react-hook-form";
import {
  useFieldPathWithPrefix,
  useFieldErrorWithPrefix,
} from "@/forms/FormFieldPathPrefixContext";
import type { TemplateTitleInputFields } from "../templateFormSchema";

export const TemplateTitleInput = () => {
  const {
    formState: { errors },
    register,
    trigger,
    clearErrors,
  } = useFormContext<FieldValues>();

  const { t } = useLingui();
  const fieldName = useFieldPathWithPrefix<TemplateTitleInputFields>("title");
  const errorMessage = useFieldErrorWithPrefix<TemplateTitleInputFields>(
    errors,
    "title",
  );

  return (
    <InputField
      label={t`Titel`}
      showOptionalLabel={false}
      errorMessage={errorMessage}
      {...register(fieldName, {
        required: {
          value: true,
          message: t`Ange titel`,
        },
        maxLength: {
          value: NUMBER_OF_CHARACTERS_ALLOWED_IN_TITLE,
          message: t`Namnet får max vara ${NUMBER_OF_CHARACTERS_ALLOWED_IN_TITLE} tecken. Lägg ytterligare text i beskrivningen.`,
        },
        onChange: (e) => {
          // User feedback onChange
          if (e?.currentTarget?.value?.length >= 1) {
            void trigger(fieldName);
          } else {
            // ... but don't show annoying errors at this point if the field is empty.
            clearErrors(fieldName);
          }
        },
      })}
    />
  );
};
